import React from "react";
import PropTypes from "prop-types";

import { Caption } from "common/DS/Text";
import { staticURL } from "lib/img";
import ExternalLink from "portal/Retain/ExternalLink";
import { TranslationFn } from "lib/types";
import { preventDefault } from "lib/util";

const CURRENT_YEAR = new Date().getFullYear();

interface WindowOneTrustSdk extends Window {
    OneTrust?: {
        ToggleInfoDisplay: () => void;
    };
}

const win = window as WindowOneTrustSdk;

const CandidatePageFooter = (props: Record<string, never>, { t: _ }: { t: TranslationFn }) => (
    <footer className="check-in__footer">
        <div className="flex flex-row flex-ac">
            <Caption>Powered by</Caption>
            <img src={staticURL("workstep-logo-gray.svg")} alt="WorkStep logo" />
        </div>
        <div className="flex flex-row mt-md">
            <span>WorkStep &#xa9; {CURRENT_YEAR}</span>
            <span>&nbsp; | &nbsp; </span>
            <span>
                <ExternalLink href="/terms-of-service">{_("Terms")}</ExternalLink>
            </span>
            <span>&nbsp; | &nbsp; </span>
            <span>
                <ExternalLink href="/privacy-policy">{_("Privacy")}</ExternalLink>
            </span>
            <span>&nbsp; | &nbsp; </span>
            <span>
                <a
                    href="#"
                    onClick={preventDefault(() =>
                        win.OneTrust?.ToggleInfoDisplay ? win.OneTrust.ToggleInfoDisplay() : null,
                    )}
                >
                    {_("Cookie Settings")}
                </a>
            </span>
        </div>
    </footer>
);

CandidatePageFooter.contextTypes = {
    t: PropTypes.func,
};

export default CandidatePageFooter;
